import { render } from "./CardFile.vue?vue&type=template&id=1752bdf6"
import script from "./CardFile.vue?vue&type=script&lang=js"
export * from "./CardFile.vue?vue&type=script&lang=js"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__